import { TIME_FILTER } from 'constants/chart';
import type { ChartDataPoint, TimeFilter } from 'types/chart';

export const FILTER_BUTTONS = [
  { key: TIME_FILTER.LAST_7_DAYS, label: 'DailyTracking.Chart.last7Days' },
  { key: TIME_FILTER.MONTH, label: 'DailyTracking.Chart.chooseMonth' },
  { key: TIME_FILTER.LAST_12_MONTHS, label: 'DailyTracking.Chart.oneYear' },
] as const;

export const DATE_CONFIG = {
  MONTHS_COUNT: 12,
  YEARS_RANGE: 5,
  YEARS_OFFSET: 2,
} as const;

export const SELECT_CONFIG = {
  SIZE: 'sm' as const,
  GAP: 'gap-2',
} as const;

export const SELECT_FIELDS = {
  MONTH: {
    field: 'month' as const,
    placeholderKey: 'DailyTracking.Chart.month',
    getValue: (selectedMonth: { year: number; month: number } | null) =>
      selectedMonth?.month?.toString() || '',
  },
  YEAR: {
    field: 'year' as const,
    placeholderKey: 'DailyTracking.Chart.year',
    getValue: (selectedMonth: { year: number; month: number } | null) =>
      selectedMonth?.year?.toString() || '',
  },
} as const;

export interface FilterButtonsProps {
  timeFilter: TimeFilter;
  selectedWeek: ChartDataPoint | null;
  selectedMonth: { year: number; month: number } | null;
  onTimeFilterChange: (filter: TimeFilter) => void;
  onSelectedWeekChange: (week: ChartDataPoint | null) => void;
  onSelectedMonthChange: (month: { year: number; month: number } | null) => void;
}
